import React, { useRef, useState } from 'react';
import { Input, Button } from 'antd';
import { DeleteOutlined, PictureOutlined } from '@ant-design/icons';
import {
  FormContainer,
  FormItemContainer,
  FormLabel as StyledFormLabel,
  FullWidthInputNumber,
} from '../Styles';
import { OptionFormProps } from '../types';

export const OptionForm: React.FC<OptionFormProps> = ({
  newOptionData,
  handleNewOptionDataChange,
  existingPicture,
  onImageFileChange,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [localPreview, setLocalPreview] = useState<string | null>(existingPicture ?? null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (fileInputRef.current) fileInputRef.current.value = '';
    setLocalPreview(URL.createObjectURL(file));
    onImageFileChange(file);
  };

  const handleRemoveImage = () => {
    setLocalPreview(null);
    onImageFileChange(null);
  };

  return (
    <FormContainer>
      <FormItemContainer>
        <StyledFormLabel>Option Name *</StyledFormLabel>
        <Input
          placeholder="Option Name"
          value={newOptionData.option}
          onChange={(e) => handleNewOptionDataChange('option', e.target.value)}
        />
      </FormItemContainer>

      <FormItemContainer>
        <StyledFormLabel>Description</StyledFormLabel>
        <Input
          placeholder="Description"
          value={newOptionData.description}
          onChange={(e) => handleNewOptionDataChange('description', e.target.value)}
        />
      </FormItemContainer>

      <FormItemContainer>
        <StyledFormLabel>Price *</StyledFormLabel>
        <FullWidthInputNumber
          placeholder="Price"
          value={newOptionData.price ? parseFloat(newOptionData.price) : undefined}
          onChange={(value) => handleNewOptionDataChange('price', value?.toString() || '')}
          min={0}
          step={0.01}
        />
      </FormItemContainer>

      <FormItemContainer>
        <StyledFormLabel>Image (Optional)</StyledFormLabel>
        {localPreview && (
          <div
            style={{
              marginBottom: 10,
              width: 120,
              height: 120,
              borderRadius: 10,
              overflow: 'hidden',
              border: '1px solid #e8e8e8',
              background: '#f5f5f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={localPreview}
              alt="option"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                display: 'block',
                objectFit: 'contain',
              }}
            />
          </div>
        )}
        <div style={{ display: 'flex', gap: 8 }}>
          <Button
            icon={<PictureOutlined />}
            onClick={() => fileInputRef.current?.click()}
            size="small"
          >
            {localPreview ? 'Change Image' : 'Upload Image'}
          </Button>
          {localPreview && (
            <Button
              icon={<DeleteOutlined />}
              size="small"
              danger
              onClick={handleRemoveImage}
            >
              Remove
            </Button>
          )}
        </div>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </FormItemContainer>
    </FormContainer>
  );
};
